import InfoPersoStep3FormComponent from '../../components/info-perso/InfoPersoStep3FormComponent';


export default function InfoPersoStep3Bloc() {

      return (
        <div className="">
        <div className="">
          {/* <h2 className="card-title bleu">Attestation de droits :</h2> */}
          <InfoPersoStep3FormComponent/>  
        </div>
        
      </div>
      )
}